import type { AdminCompanyDetailOutDTO, UpdateCompanyDetailInDTO } from '@api/ringil-api.v2';
import { Form, normalizeOptionalString } from '@components/pages/admin/companies/adminCompanyDetailForm.ts';

/**
 * RD-3062 — the form ↔ API mapping of `AdminCompanyDetailPage`, moved out of the component unchanged so it can be
 * unit-tested. Duplicate checks, toasts and the beta-features save stay in the component.
 */

/** The form (and its reset copy) built from the loaded company detail. */
export const adminCompanyDetailToForm = (d: AdminCompanyDetailOutDTO) => {
  const rstData = {
    contentPrefix: d.contentPrefix,
    code: d.code,
    crn: d.crn,
    tin: d.tin,
    features: d.features,
    name: d.name,
    modules: d.modules,
    dachserLastExportId: d.dachserLastExportId,
    enabledExpRequirementCodes: d.enabledExpRequirementCodes,
    prefillRequirementCodes: d.prefillRequirementCodes,
    customerReportingId: d.customerReportingId,
    defaultCurrencyIsoCode: d.defaultCurrencyIsoCode,
    defaultDistributionIntervalInHours: d.defaultDistributionIntervalInHours,
    carrierQuoteValidTillDefaultInHours: d.carrierQuoteValidTillDefaultInHours,
    responseDeadlineMode: d.responseDeadlineMode,
    aiPriceAlertsMinimalSeverity: d.aiPriceAlertsMinimalSeverity,
    invoicePublishServiceType: d.invoicePublishServiceType,
    prefixManualAppId: d.prefixManualAppId,
    entityPrefixes: d.entityPrefixes ?? [],
    autoAcceptModuleForInherited: d.autoAcceptModules,
    availableCurrencies: d.availableCurrencies,
    priceDisplayType: d.priceDisplayType,
    cargoTemplateIds: d.cargoTemplateIds,
    externalIdTypes: d.externalIdType,
    defaultTimezoneId: d.defaultTimezoneId,
  };
  return rstData;
};

/** The body of adminUpdateCompanyDetail. */
export const adminCompanyUpdateRequest = (d: Form, bypassTinValidation: boolean) =>
  ({
    name: d.name,
    features: d.features,
    companyCode: d.code,
    contentPrefix: d.contentPrefix,
    crn: d.crn,
    tin: d.tin,
    bypassTinValidation,
    dachserLastExportId: d.dachserLastExportId,
    enabledExpRequirementCodes: d.enabledExpRequirementCodes,
    prefillRequirementCodes: d.prefillRequirementCodes,
    customerReportingId: d.customerReportingId,
    defaultCurrencyIsoCode: d.defaultCurrencyIsoCode,
    defaultDistributionIntervalInHours: d.defaultDistributionIntervalInHours,
    carrierQuoteValidTillDefaultInHours: d.carrierQuoteValidTillDefaultInHours,
    responseDeadlineMode: d.responseDeadlineMode,
    aiPriceAlertsMinimalSeverity: d.aiPriceAlertsMinimalSeverity,
    invoicePublishServiceType: d.invoicePublishServiceType,
    prefixManualAppId: normalizeOptionalString(d.prefixManualAppId) ?? null,
    entityPrefixes: d.entityPrefixes,
    autoAcceptModules: d.autoAcceptModuleForInherited,
    availableCurrencies: d.availableCurrencies,
    priceDisplayType: d.priceDisplayType,
    cargoTemplateIds: d.cargoTemplateIds,
    externalIdType: d.externalIdTypes,
    defaultTimezoneId: d.defaultTimezoneId,
  } as UpdateCompanyDetailInDTO);
